<template>
  <div>
    <div class="classOrder">
      <div class="wrapsTit">选择套餐</div>
      <div class="detail">
        <div class="wrapsTits">套餐名称</div>
        <div class="wrapsCon">
          <img class="warp-img" :src="detail.coachClassTypeImage">
          <div class="content-title">{{ detail.coachClassTypeName }}</div>
          <div class="content-price">
            <span class="icon">￥</span>{{
              detail.coachClassTypePrice
            }}
          </div>
        </div>
        <el-divider />
        <template v-if="$route.query.type == 'oneToOne'">
          <!-- <div class="but">
            <div class="price">
              合计:
              <div class="price-icon">￥</div>
              <div class="price-num">
                {{
                  choose.type == 2 && !directionPrice
                    ? detail.price
                    : directionPrice
                }}
              </div>
            </div>
            <div class="but-item" @click="zhifu">提交订单</div>
          </div> -->
        </template>
        <template v-else>
          <div class="wrapsTits">
            选择套餐
            <span v-if="domain.isShop == 1" class="tips">（组合套餐可组合选择课程购买）</span>
          </div>
          <div class="type">
            <div class="type-item" :class="choose.type == 1 ? 'active' : ''" @click="choose.type = 1">
              全科套餐
              <img v-if="choose.type == 1" class="type-img"
                src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/study/choose.png" mode="aspectFit">
            </div>
            <div v-if="domain.isShop == 1" class="type-item" :class="choose.type == 2 ? 'active' : ''"
              @click="choose.type = 2">
              组合套餐
              <img v-if="choose.type == 2" class="type-img"
                src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/study/choose.png" mode="aspectFit">
            </div>
          </div>
          <el-divider />
          <!-- 组合套餐 -->
          <div v-if="choose.type == 2">
            <el-collapse class="docList">
              <el-collapse-item v-for="(item, index) in kcList" :key="index" class="item">
                <template slot="title">
                  <div class="docList-title w-b-100">
                    <div class="ellipsis">
                      {{ item.belongCourseTitleName }}
                    </div>
                    <div v-if="item.choose && item.choose.length > 0" class="chooseNum">
                      {{ item.choose ? item.choose.length : 0 }}
                    </div>
                  </div>
                </template>
                <div v-for="(kcitem, kcindex) in item.coursePurchaseList" :key="kcindex" class="docList-item"
                  :class="choose.kcides.includes(kcitem.courseId) ? 'active' : ''" @click="chooseClick(kcitem, item)">
                  <!-- {{ kcitem.yearName }}【{{ liveEnum[kcitem.type] }}】 -->
                  {{ kcitem.courseName }}
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
          <!-- 选择课程方向 -->
          <div v-if="choose.type == 1 && kcBoxList.length > 0">
            <div class="wrapsTits">选择课程方向</div>
            <div class="course">

              <div v-for="(item, index) in kcBoxList" v-if="item.isShow == 0" :key="index" class="course-item"
                :class="choose.kcBoxId == item.courseId ? 'active' : ''" @click="chooseKb(item)">
                {{ item.name }}
              </div>
            </div>
          </div>
          <!-- 全科套餐包含课程 -->
          <div v-if="choose.type == 1 && yearsList.length > 0">
            <el-divider />
            <div class="wrapsTits">全科套餐包含课程</div>
            <div class="class-cour">
              <div v-for="(item, index) in yearsList" :key="index">
                {{ index ? "·" : "" }} {{ item.kcName }}
              </div>
            </div>
          </div>
          <!-- 全科配套服务 -->
          <div v-if="choose.type == 1 && detail.coufig && detail.coufig.length > 0">
            <el-divider />
            <div class="wrapsTits">全科配套服务</div>
            <div v-if="choose.type == 1 && detail.coufig && detail.coufig.length > 0
            " class="typeList">
              <img class="type-img" src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/study/myCourse.png"
                mode="aspectFit">
              <div>
                <span v-for="(coufig, coufigindex) in detail.coufig" :key="coufigindex">
                  {{ coufigindex ? "·" : "" }}{{ coufig }}
                </span>
              </div>
            </div>
          </div>
          <div v-if="couponList && couponList.length > 0" class=" m-t-20">
            <div class="flex-between-c">
              <div class="wrapsTits">选择优惠券</div>
            </div>
            <div class="couponList">
              <div class="card" v-for="(item, index) in couponList" :key="index" @click="choose1(item)">

                <div class="bodyBody">
                  <div class="left">
                    <div class="discount" :class="item.discount >= 1000 ? 'marginTopCss' : ''">
                      <span class="number" :style="{
                        'font-size': item.discountAmount >= 100 ? '26px !important' : '38px',
                      }">{{ item.discount ? item.discount : item.discountAmount }}</span>
                      <span class="fold" style="font-weight: 700">{{ item.discount ? "折" : "元" }}</span>
                    </div>
                    <div class="prompt" v-if="item.couponType == 1">无门槛</div>
                    <div class="prompt" v-else>满{{ item.limitPrice }}元可用</div>
                  </div>
                  <div class="right">
                    <div class="rightTitle oneEllipsis">
                      <span class="tag" v-if="item.couponType == 1">无门槛</span>
                      <span class="tag" v-if="item.couponType == 2">满减券</span>
                      <span class="tag" v-if="item.couponType == 3">兑换券</span>
                      <span class="tag" v-if="item.couponType == 4">折扣券</span>
                      <span class="text">{{ item.couponName }}</span>
                    </div>
                    <div :class="{ rightM: true, mt8: item.scopeType == 2, mt15: item.scopeType != 2 }">有效期至：{{
                      item.endTime }}
                    </div>

                  </div>
                  <!-- 选中 -->
                  <template> 
                    <img src="@/assets/coupons/check-i.png" class="check" v-if="item.isCheck" />
                    <img src="@/assets/coupons/check.png" class="check" v-else />
                  </template>
                </div>
                <div class="receive">
                  <img src="@/assets/coupons/bodyTitleIcon.png" class="bodyTitleIcon" />
                  <div class="receive-text oneEllipsis">
                    <span v-if="item.scopeType == 1">全站通用（不包括：拼团、限时折扣、助力）</span>
                    <span v-else-if="item.scopeType == 2">指定商品可用(课程、专栏、知识套餐、训练营、活动、资料)</span>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="but">
            <div v-if="choose.type == 2" class="price">
              合计:
              <div class="price-icon">￥</div>
              <div class="price-num">{{ allPrice }}</div>
            </div>
            <div class="but-item" @click="zhifu">提交订单</div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
// import {  getClassss } from '@/api/home'
// import wxPayment from './wxPayment.vue'
import { getInfo, getDomain } from '@/api/cookies'
// import { OrderClient } from '@/api/orderClient'
// const orderClient = new OrderClient()
// import { Know } from '@/api/know'
import { liveEnum } from '@/api/emun'
// const know = new Know()
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
export default {
  components: {
    // wxPayment 
  },
  data() {
    return {
      liveEnum: liveEnum,
      classId: null,
      domain: getDomain(),
      detail: {}, // 班型详情
      choose: {
        type: 1,
        kcBoxId: 0,
        kcdetail: [],
        kcides: []
      },
      yearsList: [],
      kcBoxList: [],
      kcList: [],
      allPrice: 0,
      directionPrice: 0,
      directionBox: {},
      loading: null,
      price: 0,
      couponList: [],
      couponCode: [],
    }
  },
  beforeDestroy() {
    this.loading.close()
  },

  async created() {
    if (this.$route.query.direction) {
      this.choose.kcBoxId = await this.$route.query.direction
    }

    this.userInfo = await getInfo()
    this.$nextTick(() => {
      if (!this.userInfo) {
        Vue.prototype.goLoginView(false)
        return
      }
    })
    this.classId = this.$route.query.classId
    await this.getDetail()
    // await this.getkcBox()
    this.getyears()
    await this.getMyCouponByKnowledgeProduct()
  },
  methods: {
    choose1(item) {
      console.log(item,'999999999999999');
      this.$set(item, 'isCheck', !item.isCheck)
      const obj = [];
      this.couponList.forEach((item) => {
        if (item.isCheck) {
          obj.push(item.code);
        }
      });
      this.couponCode = obj;
    },

    /* 查询当前用户可用优惠券 */
    async getMyCouponByKnowledgeProduct() {
      await homeClient.getMyCouponByKnowledgeProduct(0, this.classId).then((res) => {
        if (res.code == 0) {
          this.couponList = res.data
        }
      })
    },
    // 课程推荐详情
    async getDetail() {
      await homeClient.getCoachInfo(this.classId).then((res) => {

        this.detail = res.data
        this.price = this.detail.discountStatus == 1 ? this.detail.discountPrice : this.detail.coachClassTypePrice;

        this.$forceUpdate()
      })
    },
    // 获取知识套餐课程
    getkcBox() {
      know.getCoursePackageList(this.classId, 9999, 1).then((res) => {
        res.rows.forEach((element) => {
          console.log(element, this.$route.query.direction)
          if (element.courseId == this.$route.query.direction) {
            this.directionPrice = element.price
            this.directionBox = element
          }
        })
        this.kcBoxList = res.rows
      })
    },
    /* 选择课程方向 */
    chooseKb(item) {
      console.log(item)
      this.choose.kcBoxId = item.courseId
      console.log(this.choose.kcBoxId)
      this.choose.name = item.name
      this.directionPrice = item.price
      this.$forceUpdate()
    },
    /* 组合购买内容 */
    async getkc(kid) {
      let data = []
      await know
        .getClassesCourseBuyList(this.classId, undefined, kid, this.userInfo.userId)
        .then((res) => {
          if (res.code == 0) {
            for (const item of res.data.audio) {
              item.type = 3
              data.push(item)
            }
            for (const item of res.data.face) {
              item.type = 5
              data.push(item)
            }
            for (const item of res.data.imageText) {
              item.type = 4
              data.push(item)
            }
            for (const item of res.data.live) {
              item.type = 1
              data.push(item)
            }
            for (const item of res.data.video) {
              item.type = 2
              data.push(item)
            }
          }
          console.log(data, 'data')
          data = data.filter((item) => item.entrantsPass == 1)
          console.log(data, 'data1')
        })
      return data
    },
    /* 获取知识套餐包含课程名 */
    async getyears() {
      this.loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: '',
        background: 'rgba(0, 0, 0, 0.2)'
      })
      await homeClient.queryPurchaseCourse(this.classId).then((res) => {
        this.kcList = res.data.cnoPurchaseList;
        for (let item of this.kcList) {
          item["num"] = 0;
        }

      })
      this.loading.close()
    },
    /* 选中组合购买 */
    chooseClick(kcitem, father) {

      if (this.choose.kcides.includes(kcitem.courseId)) {
        this.choose.kcdetail = this.choose.kcdetail.filter((item, index) => {
          return item.courseId != kcitem.courseId
        })
      } else {
        this.choose.kcdetail.push(kcitem)
      }
      this.choose.kcides = this.choose.kcdetail.map((item, index) => {
        return item.courseId
      })
      const price = this.choose.kcdetail.map((item, index) => {
        return item.price
      })
      var sum = 0
      for (const i of price) {
        sum += i
      }
      this.allPrice = sum
      console.log(father, 'father');

      father.choose = father.coursePurchaseList.filter((item, index) => {
        return this.choose.kcides.includes(item.courseId)
      })


      this.$forceUpdate()
    },
    zhifu() {
      if (this.userInfo) {
        if (this.choose.type == 1) {
          let arr = [];
          let obj = {
            commodityTypeCode: 0,
            commodityId: this.classId,
            discount: Number(this.detail.discountStatus == 1),
          };
          arr.push(obj);
          homeClient
            .addPayOrders(arr, this.couponCode?.length ? this.couponCode.join(',') : undefined)
            .then((res) => {
              if (res.code == 0) {
                this.$router.push(`/orders/${res.data.orderNum}`)
              } else {
                this.$message.error(res.msg)
              }
            })

        } else {
          console.log(this.choose, 'this.choose');

          let arr = [];
          for (let item of this.choose.kcdetail) {
            let obj = {
              commodityTypeCode: item.courseType,
              commodityId: item.courseId,
            };
            arr.push(obj);
          }
          homeClient
            .addPayOrders(arr, undefined)
            .then((res) => {
              if (res.code == 0) {
                this.$router.push(`/orders/${res.data.orderNum}`)
              } else {
                this.$message.error(res.msg)
              }
            })
        }
      } else {
        Vue.prototype.goLoginView(true)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.classOrder {
  width: 1220px;
  margin: 40px auto;

  // 标题
  .wrapsTit {
    font-size: 28px;
    font-family: Microsoft YaHei-Regular;
    font-weight: 400;
    color: #333333;
    line-height: 28px;
    margin-bottom: 32px;

    .tips {
      color: #999999;
    }
  }

  .detail {
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    padding: 40px;
  }

  // 小标题
  .wrapsTits {
    font-size: 16px;
    font-family: Microsoft YaHei-Regular;
    font-weight: 400;
    color: #333333;
    line-height: 16px;
  }

  .wrapsCon {
    width: 100%;
    height: 138px;
    background: #f5f7f9;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    margin-top: 20px;
    padding: 24px;
    display: flex;

    .warp-img {
      width: 160px;
      height: 90px;
      border-radius: 8px 8px 8px 8px;
      opacity: 1;
      flex-shrink: 0;
      margin-right: 16px;
    }

    .content-title {
      width: 100%;
      font-size: 16px;
      font-family: Microsoft YaHei-Regular;
      font-weight: 400;
      color: #333333;
      line-height: 16px;
    }

    .content-price {
      font-size: 24px;
      font-family: Microsoft YaHei-Bold;
      font-weight: bold;
      color: #333333;
      line-height: 90px;

      .icon {
        font-size: 14px;
        font-family: Microsoft YaHei-Regular;
        font-weight: 400;
        color: #333333;
        line-height: 14px;
      }
    }
  }

  .type {
    display: flex;
    margin-top: 20px;

    .type-item {
      width: 140px;
      height: 56px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      opacity: 1;
      border: 1px solid #dddddd;
      font-size: 16px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      line-height: 56px;
      text-align: center;
      position: relative;
      cursor: pointer;

      &+.type-item {
        margin-left: 20px;
      }
    }

    .type-img {
      position: absolute;
      right: 0px;
      bottom: 0px;
      width: 32px;
      height: 32px;
    }
  }
}

/* 选择套餐 */
.typeList {
  margin-top: 20px;
  height: 44px;
  background: linear-gradient(118deg, #ffedc8 0%, #f9d996 100%);
  border-radius: 48px 48px 48px 48px;
  opacity: 1;
  font-size: 16px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: #5f502e;
  line-height: 44px;
  display: inline-flex;
  align-items: center;
  padding: 0px 16px 0px 13px;

  .type-img {
    width: 42px;
    height: 42px;
  }
}

.docList {
  .docList-title {
    height: 48px;
    background: #f5f7f9;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 48px;
    border-bottom: 1px solid #eee;
    padding: 0px 20px;
    position: relative;
    display: flex;
    align-items: center;

    .chooseNum {
      width: 20px;
      height: 20px;
      background: #ff5e51;
      opacity: 1;
      border-radius: 50%;
      line-height: 20px;
      font-size: 12px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      text-align: center;
      margin-left: 15px;
      flex-shrink: 0;
    }
  }

  /deep/ .el-collapse-item {
    margin-top: 20px;
  }
}

/deep/ .el-collapse {
  border: none;

  .el-collapse-item__wrap {
    border: none;
  }

  .el-collapse-item__header {
    height: 48px;
    background: #f5f7f9;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 48px;
    padding: 0px 20px;
  }

  .el-collapse-item__content {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;

    .docList-item {
      height: 36px;
      background: #ffffff;
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
      border: 1px solid #dddddd;
      padding: 0px 16px;
      font-size: 14px;
      font-family: PingFang SC-Regular;
      font-weight: 400;
      color: #666666;
      line-height: 36px;
      cursor: pointer;
      margin-left: 12px;
      margin-bottom: 20px;
    }
  }
}

/* 选择课程方向 */
.course {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;

  .course-item {
    height: 36px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid #dddddd;
    padding: 0px 16px;
    font-size: 14px;
    font-family: PingFang SC-Regular;
    font-weight: 400;
    color: #666666;
    line-height: 36px;
    cursor: pointer;
    margin-bottom: 24px;

    &+.course-item {
      margin-left: 12px;
    }
  }
}

/*全科套餐包含课程  */
.class-cour {
  margin-top: 16px;
  font-size: 14px;
  font-family: PingFang SC-Regular;
  font-weight: 400;
  color: #666666;
  line-height: 14px;
  display: flex;
  flex-wrap: wrap;
}

.el-divider--horizontal {
  margin: 40px 0px;
}

/* 选中状态 */
.active {
  color: #ff5e51 !important;
  border: 1px solid #ff5e51 !important;
}

.but {
  height: 128px;
  background: #ffffff;
  width: 100%;
  opacity: 1;
  padding: 40px 29px;
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .price {
    font-size: 18px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 18px;
    margin-right: 40px;
    display: flex;
    align-items: flex-end;

    .price-icon {
      color: #ff5e51;
    }

    .price-num {
      color: #ff5e51;
      font-weight: Bold;
      line-height: 32px;
      font-size: 32px;
    }
  }

  .but-item {
    width: 170px;
    cursor: pointer;
    height: 48px;
    background: #ff5e51;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 48px;
    float: right;
  }
}

.couponList {
  min-height: 120px;
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;

  .coupon-item {
    width: 365px;
    height: 104px;
    background: #fff;
    border-radius: 4px;
    display: flex;
    margin-bottom: 12px;

    .item-left {
      width: 103px;
      height: 104px;
      flex-shrink: 0;
      background: #fe7980;
      box-shadow: 0px 1px 6px 0px rgba(133, 133, 133, 0.16);
      border-radius: 4px 0px 0px 4px;

      .item-price {
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #fff;
        line-height: 103px;
        flex-shrink: 0;
        text-align: center;

        /*    display: flex;
            align-items: center;
            justify-content: center; */
        .unit {
          font-size: 16px;
          line-height: 103px;
          font-weight: bold;
        }
      }
    }

    .xuxian {
      width: 1px;
      height: 100%;
    }

    .item-right {
      width: 100%;
      margin-left: 15px;
      display: flex;
      justify-content: space-between;

      .title {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 14px;
        margin-top: 23px;
      }

      .time {
        font-size: 11px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ff6a6f;
        line-height: 12px;
        margin-top: 6px;
      }

      .item-but {
        flex-shrink: 0;
        margin: auto 0px;
        margin-right: 44px;

        .iconfont {
          font-size: 20px;
        }

        .icon-xuanzhong {
          color: #ff6a6f;
        }
      }
    }
  }

  .nothing {
    min-height: 120px;
  }
}

.card {
  width: 433px;
  border-radius: 12px;
  background: linear-gradient(180deg, #ff7c6a 0%, #ff2433 52%, #fe7367 100%);
  margin-bottom: 20px;
  padding: 14px;
  margin-right: 24px;
  position: relative;

  &:nth-child(2n) {
    margin-right: 0;
  }

  // 遮罩
  .mask {
    width: 433px;
    height: 100%;
    position: absolute;
    border-radius: 12px 12px 12px 12px;
    left: 0;
    top: 0;
    background-color: rgba(255, 255, 255, 0.4);
    z-index: 5;
  }

  // 印章
  .sealOld {
    width: 75px;
    height: 56px;
    background-image: url("~@/assets/coupons/old.png");
    position: absolute;
    top: 36px;
    right: 24px;
    z-index: 6;
  }

  .sealUsed {
    width: 75px;
    height: 56px;
    background-image: url("~@/assets/coupons/used.png");
    position: absolute;
    top: 36px;
    right: 24px;
    z-index: 6;
  }

  .check {
    width: 18px;
    height: 18px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 16px;
  }

  .title {
    font-size: 12px;
    color: #ffffff;
  }

  .bodyBody {
    width: 401px;
    min-height: 92px;
    background-image: url("https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/sk7.png");
    background-size: 100% 100%;
    // box-shadow: 0px 0px 6px 1px #e82323;
    border-radius: 12px;
    display: flex;
    align-items: center;
    position: relative;

    .left {
      width: 94px;
      text-align: center;

      .discount {
        .number {
          color: #ff0000;
          font-size: 38px;
          font-weight: 700;
        }

        .fold {
          color: #ff0000;
          font-size: 15px;
        }
      }

      .prompt {
        font-size: 10px;
        color: #8c2306;
      }
    }

    .right {
      width: 295px;
      padding: 11px 17px;

      .rightTitle {
        .tag {
          display: inline-block;
          background: linear-gradient(180deg, #ff7c6a 0%, #ff2433 52%, #fe7367 100%);
          border-radius: 4px;
          font-size: 12px;
          padding: 1px 4px;
          color: #ffffff;
        }

        .text {
          margin-left: 5px;
          font-size: 14px;
          font-weight: 600;
          color: #8c2306;
          line-height: 21px;
        }
      }

      .rightM {
        font-weight: 400;
        color: #8c2306;
        font-size: 12px;
      }

      .rightB {
        margin-top: 8px;
        font-size: 12px;
        color: #ab6a57;
        cursor: pointer;
        display: flex;
        align-items: center;

        .rightBIcon {
          margin-left: 6px;
        }
      }
    }
  }

  .receive {
    margin-top: 12px;
    display: flex;
    align-items: center;

    .bodyTitleIcon {
      width: 13px;
      height: 12px;
    }

    .receive-text {
      flex: 1;
      font-size: 12px;
      color: #fff;
      margin: 0 7px;
    }

    .right {
      .button {
        width: 84px;
        height: 30px;
        background: linear-gradient(180deg, #ffffff 0%, #ffc1c7 100%);
        border-radius: 15px;
        font-size: 14px;
        font-weight: 400;
        color: #df0006;
        text-align: center;
        line-height: 30px;
        cursor: pointer;
      }
    }
  }
}
</style>